import React, { useContext, useState, Fragment } from 'react';

import { ComponentContext } from '../../context/componentContext';

import WalletCard from '../../components/Wallet/WalletCard';
import Pay from '../../components/Wallet/Pay';
import WalletFinances from '../../components/Wallet/WalletFinances';
import Button from '../../components/helpers/Button';

const Wallet = () => {
  document.title = 'CrowdFarmer | Wallet';

  const { menuOpen } = useContext(ComponentContext);

  const [wallets] = useState(true);

  return (
    <Fragment>
      {wallets ? (
        <div className="pt-40">
          <div
            className={`flex flex-wrap justify-between mb-10 lg:px-48 lg:pr-20 ${
              menuOpen ? 'pl-14 md:pl-48 md:pr-8' : 'px-4 md:px-8'
            }`}
          >
            <h2>Farm(s) Financials.</h2>
          </div>

          <WalletFinances isMenuOpen={menuOpen} />
          <Pay isMenuOpen={menuOpen} />

          <div
            className={`bg-cf-400 py-40 lg:pl-48 lg:pr-20 ${
              menuOpen ? 'pl-14 pr-2 md:pl-48 md:pr-8' : 'px-4 md:px-8'
            }`}
          >
            <div className="container mx-auto">
              <div className="flex flex-wrap">
                <h4 className="">Here's what is happening in your wallet</h4>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4 lg:gap-12">
                <div className="">
                  <WalletCard />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="wallet-bg pt-64 md:pt-40">
          <div
            className={`flex flex-col items-center justify-center text-center px-16 ${
              menuOpen ? 'md:pl-48 md:px-0 lg:pl-0' : ''
            }`}
          >
            <h2>You have no recorded financials yet.</h2>
            <p className="text-base md:text-2xl">
              Start farming with Complete farmer to explore more <br />
              on managing your farm financial.
            </p>

            <div className="mt-6">
              <Button
                className="bg-cf-300 text-white px-10 py-4 rounded font-header"
                name="Get Started"
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Wallet;
